import {
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
	styled,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { store } from 'src/feature-app';
import { OneFormState } from 'src/types';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	/*align-items: center;*/
	height: 100vh;
	padding: 100px 15%;
`;

interface props {
	title?: string;
	text?: string;
}

export const Error = (props: props) => {
	const { title, text } = props;
	const { formInfo }: OneFormState = store.getState();
	const { notALayer, formTheme, formType } = formInfo;

	return (
		<Wrapper>
			<Text
				appearance={TokenTextAppearance.headline300}
				bold
				textAlign={TextAlignment.left}
				color={
					formTheme == 'inverted'
						? TokenTextColor.primary
						: TokenTextColor.inverted
				}
			>
				{title ? title : 'Uy, algo ha pasado'}
			</Text>
			<Text
				textAlign={TextAlignment.left}
				color={
					formTheme == 'inverted'
						? TokenTextColor.primary
						: TokenTextColor.inverted
				}
			>
				{text
					? text
					: 'Por alguna razón no hemos podido realizar la petición.'}
			</Text>
		</Wrapper>
	);
};
